'use client';
import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useParams } from 'next/navigation';

import webStorageKeys from '@/constants/web-storage-keys';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';

const FeatureUpdatedModal = dynamic(
	() => import('./feature-updated-modal').then(m => m.FeatureUpdatedModal),
	{ ssr: false }
);

export const FeatureUpdatedModalLoader = () => {
	const { sport, matchId } = useParams();
	const { SiteConfigsData: siteConfig } = useGetSiteConfigs();

	const [shouldRender, setShouldRender] = useState(false);

	useEffect(() => {
		const hasShown = localStorage.getItem(webStorageKeys.HAS_SHOWN_UPDATE_BETTYPE_1X2_ORDER_POPUP) === 'true';
		const isTargetSport = [1, 997, 9900, 9901].includes(Number(sport));
		const isConfigEnabled = Boolean(siteConfig?.EnableOddsPageFeatureUpdatePopup);

		if (!hasShown && isTargetSport && !matchId && isConfigEnabled) {
			setShouldRender(true);
		} else {
			setShouldRender(false);
		}
	}, [sport, matchId, siteConfig?.EnableOddsPageFeatureUpdatePopup]);

	if (!shouldRender) {
		return null;
	}

	return <FeatureUpdatedModal />;

};